document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('#MobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      const next = Number(input.value) + (button.hasAttribute('data-quantity-plus') ? 1 : -1);
      input.value = Math.max(1, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-add-to-cart-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const originalLabel = button?.textContent;
      if (button) button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add this item to the cart.');
        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Unable to refresh the cart.');
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
        });
      } catch (error) {
        const message = document.createElement('p');
        message.className = 'cart-error';
        message.setAttribute('role', 'alert');
        message.textContent = error.message;
        form.appendChild(message);
      } finally {
        if (button) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }
    });
  });
});
